import React, { Component } from 'react'
import { connect } from 'react-redux'
import { 
    BrowserView,
    TabletView,
    isMobile,
    isTablet
} from 'react-device-detect'
import cx from 'classnames'
import { tween } from 'popmotion'
import styler from 'stylefire'

import { setActiveVideoIdx } from '../../../actions'

import './hero-unit-video.scss'

class HeroUnitVideo extends Component {

    state = {
        featuredPartners: [],
        activeVideo: 0,
        videoLoaded: false,
        transformY: 0
    }

    constructor (props) {
        super(props)

        this.videoEl = React.createRef()
        this.progressBarEl = React.createRef()
    }

    static getDerivedStateFromProps (nextProps, prevState) {
        if (prevState.featuredPartners.length === 0) {
            const featuredPartners = nextProps.featuredPartners.map(a => {
                a.videoUrl = encodeURI(a.videoUrl)
                return a
            })
            return { featuredPartners }
        } 
        return {}
    }

    onScroll = e => {
        this.setState({ transformY: -window.pageYOffset * 0.11 })
    }

    onTimeUpdate = () => {
        const { currentTime, duration } = this.videoEl.current
        const normalizedTime = currentTime / duration
        this.progressStyler.set('scaleX', normalizedTime)
    }

    onPlay = () => {
        this.progressStyler.set('transform-origin', '0 0')
    }

    onEnded = () => {
        this.progressStyler.set('transform-origin', '100% 0')
        tween({ from: 1, to: 0, duration: 1000 }).start(v => {
            this.progressStyler.set('scaleX', v)
        })
        tween({ from: 1, to: 0, duration: 1000 }).start({
            update: v => {
                this.videoStyler.set('opacity', v)
            },
            complete: () => {
                let { activeVideo } = this.state
                activeVideo += 1
                if (activeVideo === this.state.featuredPartners.length) {
                    activeVideo = 0
                }
                this.setState({ activeVideo })
                this.props.dispatch(setActiveVideoIdx(activeVideo))
                tween({ duration: 1000 }).start(v => {
                    this.videoStyler.set('opacity', v)
                })
            }
        })
    }

    componentDidMount () {
        if (!isMobile || isTablet) {
            if (this.videoEl.current.readyState === 4) {
                this.setState({ videoLoaded: true })
            } else {
                this.videoEl.current.addEventListener('loadeddata', () => {
                    this.setState({ videoLoaded: true })
                })
                this.videoEl.current.addEventListener('canplaythrough', () => {
                    this.setState({ videoLoaded: true })
                })
            }

            this.progressStyler = styler(this.progressBarEl.current)
            this.videoStyler = styler(this.videoEl.current)

            // this.videoEl.current.defaultPlaybackRate = 10

            this.videoEl.current.addEventListener('timeupdate', this.onTimeUpdate, false)
            this.videoEl.current.addEventListener('play', this.onPlay, false)
            this.videoEl.current.addEventListener('ended', this.onEnded, false)

        }
        
        window.addEventListener('mousewheel', this.onScroll, false)
        window.addEventListener('scroll', this.onScroll, false)
    }

    componentWillUnmount () {
        this.videoEl.current.removeEventListener('timeupdate', this.onTimeUpdate, false)
        this.videoEl.current.removeEventListener('play', this.onPlay, false)
        this.videoEl.current.removeEventListener('ended', this.onEnded, false)

        window.removeEventListener('mousewheel', this.onScroll)
        window.removeEventListener('scroll', this.onScroll)
    }

    render () {
        const {
            transformY,
            videoLoaded,
            featuredPartners
        } = this.state

        const style = { transform: `translateY(${transformY}px)` }
        const videoClassName = cx({ loaded: videoLoaded })

        const videoURL = featuredPartners[this.state.activeVideo] ?
                         featuredPartners[this.state.activeVideo].videoUrl :
                         ''

        return (
            <div className="hero-unit-video">
                <BrowserView>
                    <div
                        ref={this.progressBarEl} 
                        className="progress-video-bar"></div>
                    <video 
                        ref={this.videoEl}
                        autoPlay 
                        muted
                        playsInline
                        className={videoClassName}
                        style={style}
                        src={videoURL}>
                    </video>
                </BrowserView>
                <TabletView>
                    <div
                        ref={this.progressBarEl}  
                        className="progress-video-bar"></div>
                    <video 
                        ref={this.videoEl}
                        autoPlay 
                        muted
                        playsInline
                        className={videoClassName}
                        style={style}
                        src={videoURL}>
                    </video>
                </TabletView>
            </div>
        )
    }
}

export default connect()(HeroUnitVideo)


// WEBPACK FOOTER //
// ./src/components/hero-unit/hero-unit-video/index.jsx